import React from 'react';
import { useSelector } from 'react-redux';

import { selectOffer } from 'shared/selectors';
import { isVillagePromotionsShown } from 'shared/selectors/isVillagePromotionsShown';
import { selectAgent } from 'shared/selectors/selectAgent';
import { villagePromotionsSelector } from 'shared/selectors/villagePromotionsSelector';
import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { VillagePromotions } from '../../components/VillagePromotions/VillagePromotions';
import { IPromotions } from '../../types/villagePromotions';

export interface IProps {
  promos?: IPromotions[] | null;
  builder: IAgentSchema | null;
  offer: IOfferSchema;
}

export const VillagePromotionsContainer = () => {
  const builder = useSelector(selectAgent);
  const offer = useSelector(selectOffer);
  const promos = useSelector(villagePromotionsSelector);
  const isVillageShown = useSelector(isVillagePromotionsShown);

  if (!promos || !isVillageShown) {
    return null;
  }

  return <VillagePromotions builder={builder} offer={offer} promos={promos} />;
};
